<template>
  <div class="inputContainer half">
    <label v-bind:class="classObject" v-if="!hidden">{{ label }}</label>
    <slot> </slot>
  </div>
</template>
<script>
export default {
  name: 'inputContainer',
  data() {
    return {};
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    visibleLabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classObject: function () {
      return {
        'boon-multiselect-label': true,
        'boon-multiselect-label--hidden': !this.visibleLabel,
      };
    },
    hidden: function () {
      return !this.label || this.hideLabel;
    },
  },
};
</script>

<style>
.inputContainer {
  margin: 7px 14px;
}

.boon-multiselect-label {
  display: block;
  letter-spacing: 0.5px;
  color: #aaa;
  font-size: 12px;
  transition: all 0.2s ease;
}

.boon-multiselect-label--hidden {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/form/inputContainer.vue